import { designSystemColors, otherColors } from '@klv/shared/styles/colors';
import type { IRelatedContentCardVariants } from '../../types';

export const solidCardHoverColor = {
  none: designSystemColors.poppy,
  charcoal: designSystemColors.charcoal,
  lavender: designSystemColors.lavender,
  lemon: designSystemColors.lemon,
  lightSand: designSystemColors.lightSand,
  poppy: designSystemColors.poppy,
  sage: designSystemColors.sage,
};

const relatedContentCard: IRelatedContentCardVariants = {
  dark: {
    border: otherColors.relatedContentCardDarkBorder,
    buttonColor: 'light',
    buttonHoverColor: 'dark',
    defaultBackgroundHover: designSystemColors.poppy,
    defaultTextHover: designSystemColors.charcoal,
    eyebrow: designSystemColors.lemon,
    imageTextHover: designSystemColors.white,
    solidCardHoverColor,
    text: designSystemColors.white,
  },
  light: {
    border: otherColors.fadedCharcoal,
    buttonColor: 'dark',
    buttonHoverColor: 'light',
    defaultBackgroundHover: designSystemColors.charcoal,
    defaultTextHover: designSystemColors.white,
    eyebrow: designSystemColors.charcoal,
    imageTextHover: designSystemColors.white,
    solidCardHoverColor: {
      ...solidCardHoverColor,
      none: designSystemColors.charcoal,
    },
    text: designSystemColors.charcoal,
  },
};

export default relatedContentCard;
